import styled from "styled-components";
import { useState } from "react";
import { selectUser } from "../../features/userSlice";
import { useSelector } from "react-redux";
import { postData } from "../../utils/api/postData";

export const MyComment = ({ questionId, parentId, replyTo, autoFocus, onSubmit }) => {
    const user = useSelector(selectUser);
    const [comment, setComment] = useState("");
    const [posting, setPosting] = useState(false);

    const handleChange = (e) => {
        setComment(e.target.value);
    };

    const handleSubmit = async () => {
        if (!comment.trim()) return;
        setPosting(true);
        await postData(`questions/${questionId}/comments`, {
            comment: comment.trim(),
            created_at: Date.now(),
            user_name: user?.displayName || user?.email || "Anonymous",
            user_img: user?.photoURL || "",
            user_id: user?.uid,
            parent_id: parentId || null,
        });
        setComment("");
        setPosting(false);
        if (onSubmit) onSubmit();
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <Comment>
            <img
                src={
                    user?.photoURL ||
                    "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
                }
                alt="avatar"
            />
            <input
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                value={comment}
                autoFocus={autoFocus}
                type="text"
                placeholder={
                    replyTo
                        ? `Reply to ${replyTo}... (Enter to post)`
                        : "Add a comment... (Press Enter to post)"
                }
            />
            <button onClick={handleSubmit} disabled={posting || !comment.trim()}>
                {posting ? "Posting..." : "Post"}
            </button>
        </Comment>
    );
};

const Comment = styled.div`
    height: 3.2rem;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #faf7f2;
    border-bottom: 0.5px solid rgba(201, 160, 99, 0.2);
    gap: 8px;
    padding: 0 10px;
    img {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        flex-shrink: 0;
    }
    input {
        border: 1px solid #e0d8cc;
        background-color: white;
        flex: 1;
        border-radius: 1.2rem;
        height: 2.2rem;
        padding: 0 16px;
        font-size: 19px;
        &:focus {
            outline: none;
            border-color: #1DA1F2;
        }
        &::placeholder {
            color: #a0a0a1;
        }
    }
    button {
        background-color: #1DA1F2;
        color: white;
        border: none;
        border-radius: 15px;
        padding: 0 18px;
        height: 2.1rem;
        font-weight: 700;
        font-size: 18px;
        cursor: pointer;
        flex-shrink: 0;
        transition: background 200ms;
        &:hover:not(:disabled) {
            background-color: #0d8ecf;
        }
        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }
`;
